import React from 'react';
import { format, isAfter, startOfToday, subDays } from 'date-fns';

import { DateInput, DatePicker } from '@zillow/constellation-10';

import type { Lease, Section } from '../../../../models/index';
import { LEASE_TERMS } from '../../../../constants';
import { DATE_PICKER_FORMAT } from '../../../../constants/stringConstants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  lease: Lease;
};

export default function LeaseTermsStartDate({ section, setSectionValues }: Props): JSX.Element {
  function onStartDateChange(formattedDate: string): void {
    setSectionValues({
      [LEASE_TERMS.FIELD_NAME.START_DATE]: formattedDate,
      //Validates end date, do not delete
      [LEASE_TERMS.FIELD_NAME.END_DATE]: getEndDate(),
    });
    validateStartDate();
  }

  function validateStartDate(): void {
    const field = section.getField(LEASE_TERMS.FIELD_NAME.START_DATE);

    if (isAfter(startOfToday(), getStartDate())) {
      field.setErrorMessage(LEASE_TERMS.ERROR_MESSAGE.START_DATE_IN_PAST);
    }
  }

  function getStartDate(): string {
    return section.getFieldValue(LEASE_TERMS.FIELD_NAME.START_DATE);
  }

  function getEndDate(): string {
    return section.getFieldValue(LEASE_TERMS.FIELD_NAME.END_DATE);
  }

  return (
    <DatePicker
      dateFormat={DATE_PICKER_FORMAT}
      value={getStartDate()}
      onValueChange={(value) => {
        const formatted = typeof value === 'string' ? value : format(value, DATE_PICKER_FORMAT);
        onStartDateChange(formatted);
      }}
      minDate={subDays(new Date(), 1)}
      closeModalOnDateSelect
      input={<DateInput />}
    />
  );
}
